export default {
  path: "/flow",
  name: "flow",
  component: () => import("@/views/flows/FlowBase.vue"),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: "listing",
      name: "flow_listing",
      component: () => import("@/views/flows/listing/ListingBase.vue"),
      meta: {
        steps: [
          {
            label: "Verify with Experian",
            baseRoute: "flow_listing_verify",
            completed: false,
            routes: [
              "flow_listing_verify_disclaimer",
              "flow_listing_verify_personal_info",
              "flow_listing_verify_questions"
            ]
          },
          {
            label: "Create a form",
            baseRoute: "flow_listing_new_form",
            completed: false,
            routes: ["flow_listing_new_form_reports", "flow_listing_new_form_name"]
          },
          {
            label: "Send out your form",
            baseRoute: "flow_listing_share_form",
            completed: false,
            routes: ["flow_listing_share_form"]
          }
        ],
        redirectRoute: "dashboard_forms"
      },
      children: [
        {
          path: "disclaimer",
          name: "flow_listing_verify_disclaimer",
          component: () => import("@/views/dashboard/verify/Disclaimer.vue")
        },
        {
          path: "personal_info",
          name: "flow_listing_verify_personal_info",
          component: () => import("@/views/dashboard/verify/PersonalInfo.vue")
        },
        {
          path: "questions",
          name: "flow_listing_verify_questions",
          component: () => import("@/views/dashboard/verify/Questions.vue")
        },
        {
          path: "success",
          name: "flow_listing_verify_success",
          component: () => import("@/views/dashboard/verify/Success.vue")
        },
        {
          path: "failure",
          name: "flow_listing_verify_failure",
          component: () => import("@/views/dashboard/verify/Failure.vue")
        },
        {
          path: "reports",
          name: "flow_listing_new_form_reports",
          component: () => import("@/views/dashboard/new_form/SelectReports.vue")
        },
        {
          path: "name",
          name: "flow_listing_new_form_name",
          component: () => import("@/views/dashboard/new_form/CreateLink.vue")
        }
        // {
        //   path: "share",
        //   name: "flow_listing_share_form",
        //   component: () => import("@/views/flows/listing/Share.vue")
        // }
      ]
    },
    {
      path: "money",
      name: "flow_money",
      component: () => import("@/views/flows/money/MoneyBase.vue"),
      meta: {
        steps: [
          {
            label: "Setup Payment Account",
            baseRoute: "flow_money_my_payments",
            completed: false,
            routes: [
              "flow_money_my_payments_not_enabled",
              "flow_money_my_payments_bank_account_info",
              "flow_money_my_payments_pay"
            ]
          },
          {
            label: "Ambassador Invite",
            baseRoute: "flow_money_ambassador",
            completed: false,
            routes: ["flow_money_ambassador_invite"]
          }
        ],
        redirectRoute: "dashboard_forms"
      },
      children: [
        {
          path: "not_enabled",
          name: "flow_money_my_payments_not_enabled",
          component: () => import("@/views/flows/money/NotEnabled.vue")
        },
        {
          path: "bank_account_info",
          name: "flow_money_my_payments_bank_account_info",
          component: () => import("@/views/dashboard/my_payments/signup/BankAccountInfo.vue")
        },
        {
          path: "pay",
          name: "flow_money_my_payments_pay",
          component: () => import("@/views/dashboard/my_payments/signup/Pay.vue")
        },
        {
          path: "invite",
          name: "flow_money_ambassador_invite",
          component: () => import("@/views/flows/money/AmbassadorInvite.vue")
        }
      ]
    },
    {
      path: "team",
      name: "flow_team",
      component: () => import("@/views/flows/team/TeamBase.vue"),
      meta: {
        steps: [
          {
            label: "Schedule Team Creation Meeting",
            baseRoute: "flow_team",
            completed: false,
            routes: ["flow_team_contact"]
          }
        ],
        redirectRoute: "dashboard_forms"
      },
      children: [
        {
          path: "contact",
          name: "flow_team_contact",
          component: () => import("@/views/flows/team/Contact.vue")
        }
      ]
    }
  ]
}
